<template>
  <div class="app-container">
    <div style="display: flex; justify-content: end">
      <el-input
        style="float: right; margin-right: 10px; width: 200px"
        v-model="screen.keywords"
        placeholder="姓名，手机号，公司名称"
        maxlength="11"
      ></el-input>
      <el-select
        filterable
        style="float: right; margin-right: 10px"
        v-model="screen.is_leave"
        placeholder="请选择是否离开"
      >
        <el-option label="全部" value=""></el-option>
        <el-option label="通过" value="1"></el-option>
        <el-option label="未通过" value="2"></el-option>
      </el-select>
      <el-button
        type="primary"
        @click="(screen.page = 1), fetchData()"
        style="margin-bottom: 5px; float: right"
        >搜索</el-button
      >
      <el-button
        type="primary"
        plain
        @click="reset()"
        style="margin-bottom: 5px; float: right"
        >重置</el-button
      >
    </div>

    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="所属园区" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.park ? scope.row.park.name : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="企业" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.company_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="姓名" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="身份证号">
        <template slot-scope="scope">
          <span>{{ scope.row.card }}</span>
        </template>
      </el-table-column>
      <el-table-column label="手机号码" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.phone }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="政治面貌" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.duty_number }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="申请时间" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.create_time }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="
              scope.row.status == '1'
                ? 'info'
                : scope.row.status == '2'
                ? 'success'
                : 'danger'
            "
            disable-transitions
            >{{
              scope.row.status == 1
                ? "待审核"
                : scope.row.status == 2
                ? "通过"
                : "拒绝"
            }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="160" fixed="right">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row.id)"
              v-if="roles.includes('/party/del')"
              >删除</el-button
            >
          <!-- <el-button
            size="mini"
            type="success"
            @click="examine(scope.row.id, 'pass')"
            v-if="roles.includes('/party/audit_pass') && scope.row.status == 1"
            >通过</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="examine(scope.row.id, 'refuse')"
            v-if="
              roles.includes('/party/audit_refuse') && scope.row.status == 1
            "
            >拒绝</el-button
          >
          <el-button
            size="mini"
            type="warning"
            @click="handleInfo(scope.row.id)"
            v-if="roles.includes('/party/refuse_view') && scope.row.status == 3"
            >拒绝原因</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-dialog
      title="审批"
      :visible.sync="dialogVisible"
      width="700px"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <!-- <el-form-item
          label="审核"
          prop="status"
          :rules="[
            { required: true, message: '请选择审核', trigger: 'change' },
          ]"
        >
          <el-radio-group v-model="form.status">
            <el-radio :label="2">通过</el-radio>
            <el-radio :label="3">驳回</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <div v-if="examineType == 'pass'">
          <el-form-item label="选择城市" required>
            <el-col :span="8">
              <el-form-item prop="province_id">
                <el-select
                  filterable
                  v-model="form.province_id"
                  placeholder="请选择省份"
                  @change="provinceChange"
                >
                  <el-option
                    v-for="(item, index) in provinceList"
                    :key="index"
                    :label="item.province"
                    :value="item.province_id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="city_id">
                <el-select
                  @change="cityChange"
                  filterable
                  v-model="form.city_id"
                  placeholder="请选择城市"
                >
                  <el-option
                    v-for="(item, index) in cityList"
                    :key="index"
                    :label="item.city"
                    :value="item.city_id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="area_id">
                <el-select
                  filterable
                  v-model="form.area_id"
                  placeholder="请选择区域"
                >
                  <el-option
                    v-for="(item, index) in areaList"
                    :key="index"
                    :label="item.area"
                    :value="item.area_id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item prop="location" label="详细地址">
            <el-input type="textarea" v-model="form.location"></el-input>
          </el-form-item>
        </div>
        <div v-if="examineType == 'refuse'">
          <el-form-item prop="refuse" label="拒绝原因">
            <el-input type="textarea" v-model="form.refuse"></el-input>
          </el-form-item>
        </div>
        <el-form-item v-if="seeType == 'see'">
          <el-button @click="dialogVisible = false">关 闭</el-button>
        </el-form-item>
        <el-form-item v-else>
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('form')"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { openPark, delImage } from "@/api/index";
import {
  party_list,
  audit_pass,
  audit_refuse,
  refuse_view,
  get_province,
  get_city,
  get_area,
  partyDel
} from "@/api/party";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      infoForm: {},
      token: getToken(),
      list: [],
      listLoading: true,
      screen: {
        page: 1,
        page_size: 15,
        is_leave: "",
        keywords: "",
      },
      total: 0,
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      dialogVisible: false,
      form: {
        id: "",
        status: "",
        reason: "",
        url: "",
      },
      rules: {
        status: [{ required: true, message: "请选择审核", trigger: "change" }],
        refuse: [
          { required: true, message: "请输入拒绝意见", trigger: "blur" },
        ],
        location: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        province_id: [
          {
            type: "date",
            required: true,
            message: "请选择省份",
            trigger: "change",
          },
        ],
        city_id: [
          {
            type: "date",
            required: true,
            message: "请选择城市",
            trigger: "change",
          },
        ],
        area_id: [
          {
            type: "date",
            required: true,
            message: "请选择区域",
            trigger: "change",
          },
        ],
      },
      drawer: false,
      fileList: [],
      examineType: "",
      provinceList: [],
      cityList: [],
      areaList: [],
      seeType: "",
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
  },
  methods: {
    // 查看
    handleInfo(id) {
      // this.drawer = true;
      var that = this;
      this.examineType = "refuse";
      this.seeType = "see";
      refuse_view({ id: id }).then((res) => {
        this.form = {
          refuse: res.data.refuse,
        };
      });
      this.dialogVisible = true;
    },
    examine(id, type) {
      this.examineType = type;
      this.seeType = "";
      if (type == "refuse") {
        this.form = {
          id: id,
          refuse: "",
        };
      } else if (type == "pass") {
        this.form = {
          id: id,
          province_id: "",
          city_id: "",
          area_id: "",
          location: "",
        };
        this.getProvince();
      }

      this.dialogVisible = true;
    },
    // 获取省份
    getProvince() {
      get_province().then((res) => {
        this.provinceList = res.data.lists;
      });
    },
    // 选择省份
    provinceChange(e) {
      this.cityList = [];
      this.areaList = [];
      this.$set(this.form, "city_id", "");
      this.$set(this.form, "area_id", "");
      this.getCity(e);
    },
    // 获取城市
    getCity(provinceId) {
      get_city({ province_id: provinceId }).then((res) => {
        this.cityList = res.data.lists;
      });
    },
    // 选择城市
    cityChange(e) {
      this.areaList = [];
      this.$set(this.form, "area_id", "");
      this.getArea(e);
    },
    // 获取区域
    getArea(cityId) {
      get_area({ city_id: cityId }).then((res) => {
        this.areaList = res.data.lists;
      });
    },
    reset() {
      this.screen = {
        park_id: "",
        page: 1,
        page_size: 15,
        keywords: "",
        is_leave: "",
      };
      // if (this.userInfo.park_id !== 0) {
      //   this.screen.park_id = this.userInfo.park_id;
      // } else {
      //   this.screen.park_id = "";
      // }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          partyDel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              if (that.examineType == "refuse") {
                audit_refuse(that.form).then((res) => {
                  if (res.code === 200) {
                    this.$message({
                      message: code.msg,
                      type: "success",
                    });
                    that.dialogVisible = false;
                    that.fetchData();
                  } else {
                    this.$message({
                      message: code.msg,
                      type: "warning",
                    });
                  }
                });
              } else {
                audit_pass(that.form).then((res) => {
                  if (res.code === 200) {
                    this.$message({
                      message: res.msg,
                      type: "success",
                    });
                    that.dialogVisible = false;
                    that.fetchData();
                  } else {
                    this.$message({
                      message: code.msg,
                      type: "warning",
                    });
                  }
                });
              }
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.form.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      party_list(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
</style>
